module.exports = __webpack_public_path__ + "images/education-skills-recruitment-word-search-bd29bc2aa6d508315e1c07069350b05b.jpg";